import * as React from 'react';
import { css } from 'aphrodite';
import { t } from '@citrite/translate';
import { MainContent } from '@citrite/workspace-ui-platform-react';
import { RoutedComponentProps } from 'Router/ReactRoute';
import { styles } from './styles';

export type Props = RoutedComponentProps;
//allow-unused-export
export class HomeWithWidgets extends React.Component<Props> {
	public render() {
		return (
			<MainContent>
				<div className={css(styles.widgets)}>{this.props.children}</div>
			</MainContent>
		);
	}

	public componentDidMount() {
		this.props.setMobileMastheadTitle(t('Workspace:home'));
	}

	public componentWillUnmount() {
		this.props.setMobileMastheadTitle('');
	}
}
